import { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { useSettings, formatMoney } from "../lib/settings";
import { useT, trText } from "../lib/i18n";

const STATUSES = ["", "needs_review", "paid", "pending", "failed", "expired", "created"];
const PILL = { paid: "pill-available", needs_review: "pill-maint", failed: "pill-returned", expired: "pill-returned" };

export default function OnlinePaymentsPage() {
  const { t } = useT();
  const { settings } = useSettings();
  const [status, setStatus] = useState("");
  const [data, setData] = useState({ items: [], needs_review: 0 });
  useEffect(() => {
    api.get("/online-payments", { params: status ? { status } : {} }).then((r) => setData(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, [status]);
  return (
    <div className="space-y-5" data-testid="online-payments-page">
      <div>
        <div className="eyebrow">{t("op.eyebrow")}</div>
        <h1 className="text-3xl font-semibold">{t("op.title")}</h1>
        <p className="text-sm text-[var(--gray-400)] mt-1">{t("op.sub")}</p>
      </div>
      {data.needs_review > 0 && (
        <button className="panel p-3 text-sm text-start border-s-4 border-amber-500 w-full" onClick={() => setStatus("needs_review")} data-testid="op-review-banner">
          {t("op.review_banner", { n: data.needs_review })}
        </button>
      )}
      <div className="panel p-3">
        <select value={status} onChange={(e) => setStatus(e.target.value)} aria-label={t("op.col_status")} className="h-11 rounded-lg border border-[hsl(var(--border))] px-3 text-sm" data-testid="op-status-filter">
          {STATUSES.map((s) => <option key={s} value={s}>{s ? t(`op.st_${s /* i18n-keys: needs_review,paid,pending,failed,expired,created */}`) : t("op.all_statuses")}</option>)}
        </select>
      </div>
      <div className="panel overflow-x-auto">
        <table className="w-full dense-table">
          <thead><tr><th>{t("op.col_date")}</th><th>{t("op.col_type")}</th><th>{t("op.col_customer")}</th><th>{t("op.col_vehicle")}</th><th>{t("op.col_amount")}</th><th>{t("op.col_status")}</th><th>{t("op.col_ref")}</th></tr></thead>
          <tbody>
            {data.items.map((a) => (
              <tr key={a.id} data-testid={`op-row-${a.id}`}>
                <td className="text-xs mono whitespace-nowrap"><bdi>{a.created_at?.slice(0, 16).replace("T", " ")}</bdi></td>
                <td className="text-xs">{a.type === "reservation_deposit" ? t("op.type_deposit") : t("op.type_balance")}</td>
                <td className="text-xs">{a.customer_name || "—"}</td>
                <td className="text-xs">{trText(a.description)}</td>
                <td className="tabular font-semibold whitespace-nowrap">{formatMoney(Number(a.amount), settings)}</td>
                <td><span className={`pill ${PILL[a.status] || "pill-reserved"}`}>{t(`op.st_${a.status /* i18n-keys: needs_review,paid,pending,failed,expired,created */}`)}</span>
                  {a.review_reason && <div className="text-xs text-amber-700 mt-1">{trText(a.review_reason)}</div>}</td>
                <td className="mono text-xs">{a.gateway_txn_id || "—"}</td>
              </tr>
            ))}
            {data.items.length === 0 && <tr><td colSpan={7} className="text-center py-8 text-[var(--gray-400)]">{t("op.empty")}</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
